import { SolidgatePaymentStatus } from '@/types/payment';
import { WAIT_BEFORE_NEXT_CHECK_ORDER_PAYMENT_STATUS_MS } from '@feature/payment/solidgate/config/solidgate.form.config';
import { useSolidgateModals } from '@feature/payment/solidgate/hooks/useSolidgateModals';
import { useCheckSolidgatePaymentStatusMutation, useSaveSolidgatePaymentCardMutation } from '@/api/order';
import { useInvalidatesTags } from '@/store/emptyApi';
import { useAppSelector } from '@/hooks/redux';
import { selectCardPreferences } from '@/store/payment/paymentSlice';

export const useSolidgateCheckOrderStatus = () => {
  const { paymentStatusModal, paymentModal } = useSolidgateModals();

  // Check payment status mutation with long polling
  const [checkPaymentStatus] = useCheckSolidgatePaymentStatusMutation();
  // -- if success, invalidate orders to refresh the payment status
  const reloadOrders = useInvalidatesTags('Order');

  const cardPreferences = useAppSelector(selectCardPreferences);
  const [saveCard] = useSaveSolidgatePaymentCardMutation();

  // Check status
  const checkOrderStatusByIdPayment = async (options: { idPayment: string; creditCardMode: boolean }) => {
    const { idPayment, creditCardMode } = options;

    paymentStatusModal.pending();

    const { id: status } = await checkPaymentStatus({ idPayment }).unwrap();

    if (status === SolidgatePaymentStatus.Pending) {
      console.time('processing');
      // Close the payment modal to prevent UI issues
      paymentModal.close();
      console.info('[check order status] ⏳Payment is still pending, checking again...');
      // simulate a delay for the next check
      await new Promise((r) => setTimeout(r, WAIT_BEFORE_NEXT_CHECK_ORDER_PAYMENT_STATUS_MS));
      // If the payment is still pending, we can set a timeout to check again later
      return checkOrderStatusByIdPayment(options);
    } else {
      console.timeEnd('processing');
      // Fail, Success or any other status
      console.log('[check order status] 🏁Payment status updated:', status);
      // Invalidate orders to refresh the payment status
      reloadOrders();

      // Close the payment modal
      paymentStatusModal.close();

      // Notify backend about the save card preference
      if (status === SolidgatePaymentStatus.Success) {
        // Never save card if not in credit card mode (Apple Pay, Google Pay)
        const body = creditCardMode ? cardPreferences : { shouldSaveCard: false, isPrimary: false };
        await saveCard({ idPayment, ...body });
      }
    }
  };

  return { checkOrderStatusByIdPayment };
};
